import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

const Shop = () => {
    const [prod, setprod] = useState([]);
    const [catg , setcatg] = useState([]);
    const [ratin, setrain] = useState(0);
    const [disc , setdisc] = useState(0);
    const [star , setart] = useState(1);
    const [end, setend] = useState(7);

    const nav = useNavigate();

    const fetchbycatg = async(cat) =>{
          let resp = await fetch(`https://dummyjson.com/products/category/${cat}`);
        if (resp.ok) {
            let res = await resp.json();
            setprod(res.products);
            setend(7)
        }
    }

     const head1 = Array.from({ length: 4 }, (_index) => (
    <i class="fa-solid fa-star" style={{color: "red"}}></i>
  ))
     const head2 = Array.from({ length: 3 }, (_index) => (
    <i class="fa-solid fa-star" style={{color: "red"}}></i>
  ))
     const head3 = Array.from({ length: 2 }, (_index) => (
    <i class="fa-solid fa-star" style={{color: "red"}}></i>
  ))

   const head = (app) =>  Array.from({ length: app}, (_index) => (
    <i class="fa-solid fa-star" style={{color: "red"}}></i>
  ))

  


    const getData = async () => {
        let resp = await fetch("https://dummyjson.com/products?limit=200");
        if (resp.ok) {
            let res = await resp.json();
            setprod(res.products);
        }
    }

    const more = () =>{
        setend(end + 6)
    }
    useEffect(() => {
        getData();
    }, [])
    return (
        <>
            <br /> <br />
            <div className="container">
                <div className="row">
                    <div className="col-lg-3 catgs">
                        <table className="table" border={1}>
                            <tr>
                                <th> Sort by Category </th>
                            </tr>
                            <tr>
                                <td onClick={()=>fetchbycatg("Beauty")}> Beauty</td>
                            </tr>
                            <tr>
                                <td onClick={()=>fetchbycatg("Fragrances")}>Fragrances</td>
                            </tr>
                            <tr>
                                <td onClick={()=>fetchbycatg("Furniture")}>Furniture</td>
                            </tr>
                            <tr>
                                <td onClick={()=>fetchbycatg("Laptops")}>Laptops </td>
                            </tr>
                            <tr>
                                <td onClick={()=>fetchbycatg("Smartphones")}>Smartphones </td>
                            </tr>
                            <tr>
                                <td onClick={()=>fetchbycatg("Sunglasses")}> Sunglasses</td>
                            </tr>
                            <tr>
                                <td onClick={()=>fetchbycatg("Tablets")}>Tablets </td>
                            </tr>
                            <tr>
                                <td onClick={()=>fetchbycatg("Tops")}>Tops</td>
                            </tr>
                        </table>
                        <table className="table" border={1}>
                            <tr> <th> Sort by Rating  </th> </tr>
                            <tr> <td onClick={()=>setrain(4)}> {head1}  </td> </tr>
                            <tr> <td onClick={()=>setrain(3)}> {head2}  </td> </tr>
                            <tr> <td onClick={()=>setrain(2)}> {head3}  </td> </tr>
                        </table>
                        <table className="table" border={1}>
                            <tr> <th> Filter by Discount  </th> </tr>
                            <tr> <td onClick={()=>setdisc(18)}> 18% discount  </td> </tr>
                            <tr> <td onClick={()=>setdisc(15)}>  15% discount  </td> </tr>
                            <tr> <td onClick={()=>setdisc(10)}> 10% discount`  </td> </tr>
                        </table>

                    </div>
                <div className="col-lg-8">
                <div className="row">
                    {

                        prod.filter(p=> p.discountPercentage >= disc && p.rating >= ratin).slice(1, 7).map((data, ind) => (
                            <>
                                <div key={ind} id="cardt" className="col-lg-4">
                                    <div> <img src={data.thumbnail} /> </div>
                                    <div> {data.title} </div>
                                    <div> {head(data.rating)} </div>
                                    <div> ${data.price} &nbsp; &nbsp; {data.discountPercentage}% </div>
                                    <button onClick={()=>nav(`view?idt=${data.id}`)} className="btn btn-primary mt-2"> View to shop </button>
                                </div>

                            </>
                        ))}
                
                                
                </div>
                </div>
            </div>
            </div>
        </>
    );
}

export default Shop;